/**
 * Institution Name Utilities
 *
 * Functions for formatting and shortening institution names.
 * Long cooperative names like "COOPERATIVA DE AHORRO Y CREDITO JARDIN AZUAYO"
 * are shortened to just "JARDIN AZUAYO" for display in limited spaces.
 */

/**
 * Shorten an institution name by removing common prefixes
 * Examples:
 * - "COOPERATIVA DE AHORRO Y CREDITO JARDIN AZUAYO" -> "JARDIN AZUAYO"
 * - "ASOCIACION MUTUALISTA DE AHORRO Y CREDITO PARA LA VIVIENDA PICHINCHA" -> "Mutualista PICHINCHA"
 * - "CAJA CENTRAL FINANCOOP" -> "FINANCOOP"
 */
export function shortenInstitutionName(fullName: string): string {
  return fullName
    .replace(/^COOPERATIVA DE AHORRO Y CREDITO\s*/i, '')
    .replace(/^ASOCIACION MUTUALISTA DE AHORRO Y CREDITO PARA LA VIVIENDA\s*/i, 'Mutualista ')
    .replace(/^CAJA CENTRAL\s*/i, '')
    .replace(/\s+LIMITADA$/i, '')
    .replace(/\s+LTDA\.?$/i, '')
    .trim();
}

/**
 * Format institution name for display - title case with shortened prefix
 */
export function formatInstitutionDisplayName(fullName: string): string {
  const shortened = shortenInstitutionName(fullName);
  // Convert to title case for better readability
  return shortened
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
